import styled from "styled-components";
import { AutoColumn } from "../../../components/Column";
import { AutoRow, RowBetween } from "../../../components/Row";
import useToken from "../../../hooks/useToken";
import { ButtonLight, ButtonPrimary } from "../../../components/Button";
import { fromAmount, toAmount, toSpecialAmount } from "../../../utils/amount";
import CurrencyLogo from "../../../components/CurrencyLogo";
import { Trans } from "@lingui/macro";
import { useWallet } from "use-wallet";
import { useEffect, useMemo, useState } from "react";
import { BLOCK_PER_SEC } from "../../../constants/chains";
import { zeroPad } from "react-countdown";
import PkgPurchaseModal from "./PkgPurchaseModal";
import Big from "big.js";
import { TOKEN_ADDRESS } from "../../../constants/address";

const PoolItemWrapper = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 12px;
  background-color: white;
  padding: 1em;
  min-height: 258.5px;
  font-size: 14px;
`;

const APYText = styled.div`
  color: ${({ theme }) => theme.yellow2};
  font-size: 20px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

const ValueText = styled.div`
  font-size: 14px;
`;

const HR = styled.div`
  width: 100%;
  border-bottom: 1px dashed ${({ theme }) => theme.bg2};
`;

function PkgItem({ pkgitem, userOpt }) {
  const { account,chainId  } = useWallet(); // getBlockNumber
  // const blockNumber = getBlockNumber();
  const [depositOpen, setDepositOpen] = useState(false);
  const [curPkgItem, setcurPkgItem] = useState({});
  
  const [token] = useToken(TOKEN_ADDRESS[chainId]);

  return (
    <PoolItemWrapper>
      {pkgitem ? (
        <AutoColumn gap={"12px"}>
          <RowBetween justify={"space-between"}>
            <AutoRow gap={"8px"}>
              {/* <CurrencyLogo src={token.icon} size={"48px"} /> */}
              <AutoColumn>
                <div style={{ fontSize: "16px" }}>
                  <Trans> {pkgitem.name}</Trans>
                  {pkgitem.businesstype=='1'&& <>{'('}<Trans>Trial Package</Trans>{')'}</>}
                  {pkgitem.businesstype=='2'&& <>{'('}<Trans>Basic Package</Trans>{')'}</>}
                  {pkgitem.businesstype=='3'&& <>{'('}<Trans>Premium Package</Trans>{')'}</>}
                  {pkgitem.businesstype=='4'&& <>{'('}<Trans>Enterprise Package</Trans>{')'}</>}
                  
                </div>
                {/*              <div style={ { fontSize: '16px' } }>
                  <Trans>Earn</Trans>
                </div> */}
              </AutoColumn>
            </AutoRow>
            <div>#{pkgitem.pkgid}</div>
          </RowBetween>

          <HR />

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Period</Trans>
            </div>
            <APYText>{pkgitem.pkgdays} Days</APYText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Price</Trans>
            </div>
            <ValueText>
              {toSpecialAmount(pkgitem.price,18)}
            </ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Apps</Trans>
            </div>
            <ValueText>{pkgitem.appgroup}</ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>MaxCount</Trans>
            </div>
            <ValueText>{pkgitem.daymaxcount}{'/Day'}</ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>{pkgitem.desc}</Trans>
            </div>
          
          </AutoRow>

          <HR />

          <ItemActionWrapper>
            <ButtonPrimary
              padding={"8px"}
              onClick={() => {setDepositOpen(true);setcurPkgItem(pkgitem)}}
              disabled={false}
            >
              <Trans>Purchase</Trans>
            </ButtonPrimary>
          </ItemActionWrapper>
        </AutoColumn>
      ) : null}

 <PkgPurchaseModal
        isOpen={depositOpen}
        setIsOpen={setDepositOpen}
        token={token}
        userOpt={userOpt}
        pkgitem={curPkgItem}
       
      />
    </PoolItemWrapper>
  );
}

export default PkgItem;
